import React from 'react';
import styled from 'react-emotion';
import { responsiveStyle, space, width } from 'styled-system';
import { array, bool, number, oneOfType, string } from 'prop-types';
import tag from 'tag-hoc';

var responsivePropType$1 = oneOfType([number, string, array]);

var propTypes$1 = {
  width: responsivePropType$1,
  fontSize: responsivePropType$1,
  color: responsivePropType$1,
  bg: responsivePropType$1,
  m: responsivePropType$1,
  mt: responsivePropType$1,
  mr: responsivePropType$1,
  mb: responsivePropType$1,
  ml: responsivePropType$1,
  mx: responsivePropType$1,
  my: responsivePropType$1,
  p: responsivePropType$1,
  pt: responsivePropType$1,
  pr: responsivePropType$1,
  pb: responsivePropType$1,
  pl: responsivePropType$1,
  px: responsivePropType$1,
  py: responsivePropType$1
};

var removeProps = ['width', 'w', 'm', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'flex', 'order', 'wrap', 'direction', 'align', 'justify', 'column'];

var flex = responsiveStyle('flex');
var order = responsiveStyle('order');

var Tag = tag(removeProps);
var Base = Tag('div');

var Box = /*#__PURE__*/styled(Base)([], { boxSizing: 'border-box' }, width, space, flex, order);
Box.displayName = 'Box';

var responsivePropType = oneOfType([number, string, array]);

Box.propTypes = Object.assign({}, propTypes$1, {
  flex: responsivePropType,
  order: responsivePropType
});

var align = function align(props) {
  return { verticalAlign: props.align || 'top' };
};

var Grid = /*#__PURE__*/styled(Box)([], {
  display: 'inline-block'
}, align);
Grid.displayName = 'Grid';

var wrap = responsiveStyle('flex-wrap', 'wrap', 'wrap');
var direction = responsiveStyle('flex-direction', 'direction');
var align$1 = function align(props) {
  return responsiveStyle('align-items', 'align');
};
var justify = function justify(props) {
  return responsiveStyle('justify-content', 'justify');
};
var column = function column(props) {
  return props.column ? 'flex-direction:column;' : null;
};

var Flex = /*#__PURE__*/styled(Box)([], { display: 'flex' }, wrap, column, direction, align$1, justify);
Flex.displayName = 'Flex';

var responsivePropType$2 = oneOfType([number, string, array, bool]);

Flex.propTypes = Object.assign({}, propTypes$1, {
  wrap: responsivePropType$2,
  direction: responsivePropType$2,
  align: responsivePropType$2,
  justify: responsivePropType$2,
  column: bool
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var Half = function Half(props) {
  return React.createElement(Grid, _extends({}, props, { width: [1, 1 / 2] }));
};
Half.displayName = 'Half';

var Third = function Third(props) {
  return React.createElement(Grid, _extends({}, props, { width: [1, 1 / 3] }));
};
Third.displayName = 'Third';

var Quarter = function Quarter(props) {
  return React.createElement(Grid, _extends({}, props, { width: [1, 1 / 4] }));
};
Quarter.displayName = 'Quarter';

var φ = (1 + Math.sqrt(5)) / 2;
var ga = φ - 1;
var gb = 1 - ga;

var A = function A(props) {
  return React.createElement(Grid, _extends({}, props, { width: [1, ga] }));
};
var B = function B(props) {
  return React.createElement(Grid, _extends({}, props, { width: [1, gb] }));
};

var Golden = {
  A: A,
  B: B
};
Golden.displayName = 'Golden';

export { Box, Grid, Flex, Half, Third, Quarter, Golden };
